import {get, post} from './http'
import setting from "@/setting";

let URL = setting.apiBaseURL
//let CALL_URL = 'http://106.227.5.10:9090'
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
//话务条：签入
export const login = (data) => post(URL + '/bus/loginInfo/login', data);
//话务条：签出
export const logout = (data) => post(URL + '/bus/loginInfo/logout', data);

/* 热线指挥中心大屏 start*/
//坐席监控
export const getAgentList = (data) => get(URL + '/bigScreen/agentState', data);
/* 热线指挥中心大屏 end*/

/* 大唐呼叫系统 start*/
//坐席监控：在线坐席
export const getAtstarAgentState = (url, data) =>
    get(url + '/atstar/client.php/status-opv2/monitoragent', data);
//话务列表：所有坐席
export const getAtstarAgentList = (url, data) =>
    get(url + '/atstar/client.php/device-interface/index', data);
//电话控制：监听强插
export const getAtstarControl = (url, data) =>
    get(url + '/atstar/index.php/status-opv2', data);
export const getAtstarForceLogOut = (url, user_name) =>
    get(url + '/atstar/index.php/status-opv2/forceuserlogout', {user_name});
/* 大唐呼叫系统 end*/
